/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1PipelineVersion } from './V2beta1PipelineVersion';
import {
  V2beta1PipelineVersionFromJSON,
  V2beta1PipelineVersionFromJSONTyped,
  V2beta1PipelineVersionToJSON,
  V2beta1PipelineVersionToJSONTyped,
} from './V2beta1PipelineVersion';
import type { V2beta1Pipeline } from './V2beta1Pipeline';
import {
  V2beta1PipelineFromJSON,
  V2beta1PipelineFromJSONTyped,
  V2beta1PipelineToJSON,
  V2beta1PipelineToJSONTyped,
} from './V2beta1Pipeline';

/**
 *
 * @export
 * @interface V2beta1CreatePipelineAndVersionRequest
 */
export interface V2beta1CreatePipelineAndVersionRequest {
  /**
   *
   * @type {V2beta1Pipeline}
   * @memberof V2beta1CreatePipelineAndVersionRequest
   */
  pipeline?: V2beta1Pipeline;
  /**
   *
   * @type {V2beta1PipelineVersion}
   * @memberof V2beta1CreatePipelineAndVersionRequest
   */
  pipeline_version?: V2beta1PipelineVersion;
}

/**
 * Check if a given object implements the V2beta1CreatePipelineAndVersionRequest interface.
 */
export function instanceOfV2beta1CreatePipelineAndVersionRequest(
  value: object,
): value is V2beta1CreatePipelineAndVersionRequest {
  return true;
}

export function V2beta1CreatePipelineAndVersionRequestFromJSON(
  json: any,
): V2beta1CreatePipelineAndVersionRequest {
  return V2beta1CreatePipelineAndVersionRequestFromJSONTyped(json, false);
}

export function V2beta1CreatePipelineAndVersionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1CreatePipelineAndVersionRequest {
  if (json == null) {
    return json;
  }
  return {
    pipeline: json['pipeline'] == null ? undefined : V2beta1PipelineFromJSON(json['pipeline']),
    pipeline_version:
      json['pipeline_version'] == null
        ? undefined
        : V2beta1PipelineVersionFromJSON(json['pipeline_version']),
  };
}

export function V2beta1CreatePipelineAndVersionRequestToJSON(
  json: any,
): V2beta1CreatePipelineAndVersionRequest {
  return V2beta1CreatePipelineAndVersionRequestToJSONTyped(json, false);
}

export function V2beta1CreatePipelineAndVersionRequestToJSONTyped(
  value?: V2beta1CreatePipelineAndVersionRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline: V2beta1PipelineToJSON(value['pipeline']),
    pipeline_version: V2beta1PipelineVersionToJSON(value['pipeline_version']),
  };
}
